<div class="radio-container">
    <label class="radio-label">
        <input type="radio" (change)="onRadioChange($event)" [value]="value" [id]="id" [name]="name" [checked]="checked" [disabled]="disabled" />
        <span class="checkmark"></span>
        <span class="radio-label-text">{{label}}</span>
        <ng-content></ng-content>
    </label>
</div>